import { ExclamationTriangleAshIcon, XCircleAshIcon } from '@glu/icons-react';
import locale from '@glu/locale';
import { Typography } from '@glu/typography-react';
import { Button, TERTIARY } from '@glu/buttons-react';
import useStyles from './DefaultError.styles';

const ErrorSave = ({ error, onClose }: { error: string; onClose?(): void }) => {
  const classes = useStyles();
  return (
    <div className={classes.error}>
      <ExclamationTriangleAshIcon className={classes.errorExclamation} />
      <span>{error}</span>
      {onClose && (
        <Button className={classes.closeButton} onClick={onClose} variant={TERTIARY}>
          <XCircleAshIcon />
          <Typography variant="accessibility">{locale.get('dataComponents.close')}</Typography>
        </Button>
      )}
    </div>
  );
};

export default ErrorSave;
